"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Command;
(function (Command) {
    Command["ARTICLE"] = "ARTICLE";
    Command["BODY"] = "BODY";
    Command["CAPABILITIES"] = "CAPABILITIES";
    Command["DATE"] = "DATE";
    Command["GROUP"] = "GROUP";
    Command["HDR"] = "HDR";
    Command["HEAD"] = "HEAD";
    Command["HELP"] = "HELP";
    Command["LAST"] = "LAST";
    Command["LIST"] = "LIST";
    Command["LIST_ACTIVE_TIMES"] = "LIST ACTIVE.TIMES";
    Command["LIST_ACTIVE"] = "LIST ACTIVE";
    Command["LIST_DISTRIB_PATS"] = "LIST DISTRIB.PATS";
    Command["LIST_HEADERS"] = "LIST HEADERS";
    Command["LIST_NEWSGROUPS"] = "LIST NEWSGROUPS";
    Command["LIST_OVERVIEW_FMT"] = "LIST OVERVIEW.FMT";
    Command["LISTGROUP"] = "LISTGROUP";
    Command["MODE_READER"] = "MODE READER";
    Command["NEWGROUPS"] = "NEWGROUPS";
    Command["NEWNEWS"] = "NEWNEWS";
    Command["NEXT"] = "NEXT";
    Command["OVER"] = "OVER";
    Command["POST"] = "POST";
    Command["POST_SEND"] = "POST_SEND";
    Command["IHAVE"] = "IHAVE";
    Command["IHAVE_SEND"] = "IHAVE_SEND";
    Command["QUIT"] = "QUIT";
    Command["STAT"] = "STAT";
    Command["GREETING"] = "GREETING";
    Command["AUTHINFO_USER"] = "AUTHINFO USER";
    Command["AUTHINFO_PASS"] = "AUTHINFO PASS";
    Command["STARTTLS"] = "STARTTLS";
    Command["AUTHINFO_SASL"] = "AUTHINFO SASL";
    Command["COMPRESS"] = "COMPRESS";
    Command["MODE_STREAM"] = "MODE STREAM";
    Command["CHECK"] = "CHECK";
    Command["TAKETHIS"] = "TAKETHIS";
    Command["SLAVE"] = "SLAVE";
})(Command = exports.Command || (exports.Command = {}));
var CapabilityLabel;
(function (CapabilityLabel) {
    CapabilityLabel["STARTTLS"] = "STARTTLS";
    CapabilityLabel["AUTHINFO"] = "AUTHINFO";
    CapabilityLabel["READER"] = "READER";
    CapabilityLabel["NEWNEWS"] = "NEWNEWS";
    CapabilityLabel["COMPRESS"] = "COMPRESS";
    CapabilityLabel["POST"] = "POST";
    CapabilityLabel["IHAVE"] = "IHAVE";
    CapabilityLabel["OVER"] = "OVER";
    CapabilityLabel["VERSION"] = "VERSION";
    CapabilityLabel["LIST"] = "LIST";
    CapabilityLabel["IMPLEMENTATION"] = "IMPLEMENTATION";
    CapabilityLabel["STREAMING"] = "STREAMING";
    CapabilityLabel["HDR"] = "HDR";
})(CapabilityLabel = exports.CapabilityLabel || (exports.CapabilityLabel = {}));
//# sourceMappingURL=model.js.map